import { Trans, useTranslation } from 'react-i18next';

import {
    Anchor,
    Body1,
    List,
    ListItem,
    Stack,
} from '@myphx-engineering/phx-design-system';
import { useDisclosure } from '@myphx-engineering/phx-design-system/hooks';

import { PriorAuthCoverageCard } from '../PriorAuthCoverageCard';

export const ApprovedDescription = ({
    isSpecialty,
    isPrescriberOrder,
}: {
    isSpecialty?: boolean;
    isPrescriberOrder?: boolean;
}) => {
    const { t } = useTranslation();
    const [openedInsuranceinformation, { toggle: toggleInsuranceinformation }] =
        useDisclosure();

    let description;
    if (isPrescriberOrder) {
        description = isSpecialty
            ? t(
                  'priorAuthorization.statusPage.approved.description.drx.specialty'
              )
            : t(
                  'priorAuthorization.statusPage.approved.description.drx.nonSpecialty'
              );
    } else {
        description = isSpecialty ? (
            t(
                'priorAuthorization.statusPage.approved.description.nonDrxSpecialty'
            )
        ) : (
            <Trans
                i18nKey="priorAuthorization.statusPage.approved.description.nonDrx"
                components={{
                    1: <Anchor onClick={toggleInsuranceinformation} />,
                }}
            />
        );
    }

    return (
        <Stack gap="sm">
            <Body1>{description}</Body1>
            {isSpecialty ? (
                <>
                    <List>
                        <ListItem>
                            <Body1>
                                {t(
                                    'priorAuthorization.statusPage.approved.stepOne'
                                )}
                            </Body1>
                        </ListItem>
                        <ListItem>
                            <Body1>
                                {t(
                                    'priorAuthorization.statusPage.approved.stepTwo'
                                )}
                            </Body1>
                        </ListItem>
                        <ListItem>
                            <Body1>
                                {t(
                                    'priorAuthorization.statusPage.approved.stepThree'
                                )}
                            </Body1>
                        </ListItem>
                    </List>
                    <Body1>
                        {t('priorAuthorization.statusPage.approved.footNote')}
                    </Body1>
                </>
            ) : null}
            <PriorAuthCoverageCard
                opened={openedInsuranceinformation}
                onClose={toggleInsuranceinformation}
            />
        </Stack>
    );
};
